import 'dotenv/config';

export const theMovieDbUrl = `${process.env.REACT_APP_THE_MOVIE_DB_URL}`;
export const tmdbUrl = `${process.env.REACT_APP_TMDB_URL}`;
export const placeholderUrl = `${process.env.REACT_APP_PLACEHOLDER_URL}`;
export const viaPlaceholderUrl = `${process.env.REACT_APP_VIA_PLACEHOLDER_URL}`;
export const unsplashUrl = `${process.env.REACT_APP_UNSPLASH_URL}`;
